export default __webpack_public_path__ + "static/media/external.251ae874.svg";